import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubArticleEmbedEditorRoute: InvariantJiraRoute = {
	name: 'kb-article-embed-editor',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
	query: ['draftShareId?', 'topicId?'],
};
